import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { useAuth } from '../../../contexts/AuthContext';

const EmailPasswordForm = ({ mode = 'signin' }) => {
  const navigate = useNavigate();
  const { signIn, signUp } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      if (mode === 'signup') {
        // Sign up with profile metadata
        const { data, error: signUpError } = await signUp(email, password, {
          full_name: fullName,
          avatar_url: ''
        });

        if (signUpError) throw signUpError;

        setSuccess('Account created! Please check your email to confirm your account before signing in.');
        // Clear form
        setEmail('');
        setPassword('');
        setFullName('');
      } else {
        // Sign in
        const { error: signInError } = await signIn(email, password);

        if (signInError) throw signInError;

        // Navigate to file browser on success
        navigate('/file-browser');
      }
    } catch (err) {
      setError(err?.message || 'An error occurred. Please try again.');
      console.error('Authentication error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {mode === 'signup' && (
        <div>
          <label htmlFor="fullName" className="block text-sm font-medium text-foreground mb-1">
            Full Name
          </label>
          <Input
            id="fullName"
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e?.target?.value)}
            placeholder="Enter your full name"
            required
            disabled={loading}
            className="w-full"
          />
        </div>
      )}

      <div>
        <label htmlFor="email" className="block text-sm font-medium text-foreground mb-1">
          Email
        </label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e?.target?.value)}
          placeholder="Enter your email"
          required
          disabled={loading}
          className="w-full"
        />
      </div>

      <div>
        <label htmlFor="password" className="block text-sm font-medium text-foreground mb-1">
          Password
        </label>
        <Input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e?.target?.value)}
          placeholder="Enter your password"
          required
          disabled={loading}
          className="w-full"
          minLength={6}
        />
        {mode === 'signup' && (
          <p className="text-xs text-muted-foreground mt-1">
            Password must be at least 6 characters
          </p>
        )}
      </div>

      {error && (
        <div className="p-3 rounded-lg bg-destructive/10 border border-destructive/20">
          <p className="text-sm text-destructive">{error}</p>
        </div>
      )}

      {success && (
        <div className="p-3 rounded-lg bg-success/10 border border-success/20">
          <p className="text-sm text-success">{success}</p>
        </div>
      )}

      <Button
        type="submit"
        disabled={loading}
        className="w-full"
      >
        {loading ? 'Please wait...' : mode === 'signup' ? 'Create Account' : 'Sign In'}
      </Button>

      {mode === 'signup' && (
        <p className="text-xs text-muted-foreground text-center">
          After signing up, you'll receive an email confirmation link. Please verify your email before signing in.
        </p>
      )}
    </form>
  );
};

export default EmailPasswordForm;